"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExplanationCell = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
// TODO: rewrite to use MUI DataGrid cell
/** @deprecated */
const ExplanationCell = ({ explanations, rowSize = ui_components_1.DataGridRowSize.Standard, }) => {
    const { isTooltipOpen, onTooltipShow, onTooltipClose } = (0, ui_components_1.useDataGridCellTooltip)({
        contentSelector: null,
    });
    const typographyProps = {
        width: 'fit-content',
        'data-explanation-cell': true,
        align: 'left',
        variant: 'body2',
    };
    return (react_1.default.createElement(material_1.Tooltip, { arrow: true, open: isTooltipOpen, title: explanations.join(' '), onClose: onTooltipClose }, react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center', height: '100%' }, onMouseEnter: onTooltipShow }, rowSize === ui_components_1.DataGridRowSize.Standard ? (react_1.default.createElement(ui_components_1.Typography, Object.assign({ style: { textOverflow: 'ellipsis', overflow: 'hidden' } }, typographyProps), explanations[0])) : (react_1.default.createElement(react_1.default.Fragment, null, explanations.map((explanation, index) => (react_1.default.createElement(ui_components_1.Typography, Object.assign({ key: index }, typographyProps), explanation))))))));
};
exports.ExplanationCell = ExplanationCell;
